import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  headerCell: {
    fontSize: 14,
    fontWeight: 600,
  },
  colorCell: {
    minWidth: (noRemoval) => noRemoval ? 48 : 80,
    width: (noRemoval) => noRemoval ? 48 : 80,
    margin: 4,
  },
  labelCell: {
    minWidth: 120,
    width: 120,
    margin: 4,
  },
  sticky: {
    position: "sticky",
    bottom: -24,
    backgroundColor: theme.props.backgroundSecondary,
    paddingBottom: 8,
  },
}));

export default useStyle;